import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './EligibleCSBclients.style';

interface EligibleCSBclientsProps {
  item: {
    newOECount: any;
    totalOECount: any;
    reactivatedOECount: any;
  };
}
export const EligibleCSBclients = (props: EligibleCSBclientsProps) => {
  const {item} = props;

  const newClients = item?.newOECount ?? '0';
  const reactivatedClients = item?.reactivatedOECount ?? '0';
  const totalOECount = item?.totalOECount ?? '0';
  return (
    <View style={styles.row}>
      <Text
        style={styles.textStyle}
        {...testProperties(Reports.reportCoachClients)}>
        Clients: {totalOECount}
      </Text>
      <Text
        style={styles.textStyle}
        {...testProperties(Reports.reportCoachNewClients)}>
        New: {newClients}
      </Text>
      <Text
        style={styles.textStyle}
        {...testProperties(Reports.reportCoachClientsReactivated)}>
        Reactivated: {reactivatedClients}
      </Text>
    </View>
  );
};
export default withTranslation('report.record.EligibleCSBclients')(
  EligibleCSBclients,
);
